/**
 * Ren parser for home screen-widgetens deep-links.
 *
 * Widgetene åpner appen via det ALLEREDE registrerte custom-schemet
 * `com.takleconsulting.fricamp://` (Android intent-filter + iOS CFBundleURLTypes).
 * For å ikke kapre de eksisterende deep-linkene (`?verify=`, `://checkin`, OAuth-
 * redirect) gjenkjenner denne parseren KUN widgetens egen spot-lenke:
 *
 *   com.takleconsulting.fricamp://spot?spotId=<id>
 *
 * Alt annet gir `null` — kaller-siden (App.tsx `appUrlOpen`) faller da gjennom til
 * sin eksisterende ruting. Ekstrahert som ren funksjon slik at regresjonsvernet
 * (at verify/checkin fortsatt rutes riktig) kan testes uten Capacitor.
 */
export type WidgetDeepLink = { kind: 'spot'; spotId: string };

const WIDGET_SCHEME = 'com.takleconsulting.fricamp:';

export function parseWidgetDeepLink(url: string | null | undefined): WidgetDeepLink | null {
  if (!url) return null;

  let u: URL;
  try {
    u = new URL(url);
  } catch {
    return null; // malformert URL
  }

  // Kun vårt custom-scheme. https-lenker (?verify=) har protocol 'https:' → null.
  if (u.protocol !== WIDGET_SCHEME) return null;

  // Sti-basert ruting: host === 'spot'. `://checkin?spotId=` har host 'checkin' → null,
  // så widget-parseren kan aldri kapre geofence-innsjekk-lenken.
  if (u.host !== 'spot') return null;

  const spotId = u.searchParams.get('spotId');
  return spotId ? { kind: 'spot', spotId } : null;
}
